import {
    rkoBuisnessAccountSlide,
    rkoCardsSlide,
    onlineCashboxFreeBannerPages,
    transferB2B,
    ResortAcquiringPage,
} from '@/core/models/common/MainSliderSlides/Buisness/BuisnessSlidesModel';

const slidesData = [
    onlineCashboxFreeBannerPages,
    rkoBuisnessAccountSlide,
    rkoCardsSlide,
    ResortAcquiringPage,
    transferB2B,
];

const info = [
    {
        value: '0₽',
        label: 'обслуживание счета',
    },
    {
        value: 'до 5%',
        label: 'кешбэк за платежи',
    },
    {
        value: 'от 0,99%',
        label: 'эквайринг и платежи СБП',
    },
];

const offerSlidesData = [
    {
        slideImg: {
            src: 'pages/business/rko/benefit1.png',
            alt: 'Корпоративные карты Mastercard Business',
        },
        slideTitle: {
            title: 'Корпоративные карты Mastercard Business',
        },
        slideLink: '/business/corporate-cards',
    },
    {
        slideImg: {
            src: 'pages/business/rko/benefit2.png',
            alt: 'Самоинкассация',
        },
        slideTitle: {
            title: 'Самоинкассация',
        },
        slideValue: {
            value: 'Вносите наличные на&nbsp;счет через терминал самообслуживания',
        },
        slideLink: 'https://www.centrinvest.ru/cabinet/account-statement/agreement',
    },
    {
        slideImg: {
            src: 'pages/business/rko/benefit3.png',
            alt: 'Депозиты',
        },
        slideTitle: {
            title: 'Депозиты до&nbsp;20,5%',
        },
        slideValue: {
            value: 'Выберите депозит с&nbsp;максимальной выгодой',
        },
        slideLink: '/business/placement-of-funds-and-securities',
    },
];

const INFO_LIST_ITEM_ICON_PATH = 'pages/business/client-bank/check-icon.svg';

const infoListItems = [
    {
        icon: INFO_LIST_ITEM_ICON_PATH,
        value: 'Бесплатное открытие счета',
    },
    {
        icon: INFO_LIST_ITEM_ICON_PATH,
        value: 'Обслуживание&nbsp;&ndash; 0&nbsp;&#8381;/мес при любых оборотах',
    },
    {
        icon: INFO_LIST_ITEM_ICON_PATH,
        value: 'До&nbsp;1&nbsp;000&nbsp;000&nbsp;&#8381;&nbsp;перевод на&nbsp;карты без комиссии',
    },
    {
        icon: INFO_LIST_ITEM_ICON_PATH,
        value: '1,5% начисляем на&nbsp;остаток',
    },
    {
        icon: INFO_LIST_ITEM_ICON_PATH,
        value: 'Торговый эквайринг от&nbsp;1,39% с&nbsp;бесплатной установкой терминалов и&nbsp;обучением сотрудников',
    },
    {
        icon: INFO_LIST_ITEM_ICON_PATH,
        value: 'Доступный овердрафт',
    },
    {
        icon: INFO_LIST_ITEM_ICON_PATH,
        value: 'Бесплатная проверка контрагентов',
    },
];

const advantages = [
    {
        icon: '/promotions/optimal-business-solution/advantages2.svg',
        description: 'Обслуживание&nbsp;&mdash; от&nbsp;0₽/мес',
    },
    {
        icon: '/promotions/optimal-business-solution/advantages2.svg',
        description: 'Сервис Веб ТСП&nbsp;&mdash; платежи по&nbsp;QR коду',
    },
    {
        icon: '/promotions/optimal-business-solution/advantages3.svg',
        description: 'до&nbsp;1,5% начисляем на&nbsp;остаток по&nbsp;счету*',
    },
];

const tariffs = [
    {
        id: 'maximum',
        title: 'Максимум',
        maintenanceCost: 4500,
        conditions: {
            paymentsCount: [0, 0, 0, 0],
            transferAmount: [0, 0, 0, 0],
            withdrawalAmount: [0, 0, 0, 0],
        },
        tariffDescriptions: [
            {
                importantPart: '1&nbsp;000&nbsp;000&nbsp;&#8381;',
                other: 'переводы физическим лицам без комиссии*',
            },
            {
                importantPart: '100 платежей бесплатно',
                other: 'каждый последующий&nbsp;&ndash; 24&nbsp;&#8381;',
            },
            {
                importantPart: '1,5% на&nbsp;остаток',
            },
            {
                importantPart: '0,085&nbsp;% за&nbsp;внесение наличных',
            },
            {
                importantPart: 'Интернет-банк&nbsp;&ndash; бесплатно',
            },
            {
                importantPart: 'Эквайринг от&nbsp;1,39%',
            },
            {
                other: 'Обслуживание счета&nbsp;&ndash; 4500&nbsp;&#8381;/мес.',
            },
        ],
    },
    {
        id: 'optimum_plus',
        title: 'Оптимум+',
        maintenanceCost: 1200,
        conditions: {
            paymentsCount: [0, 0, 0, 2100],
            transferAmount: [0, 0, 0, 3000],
            withdrawalAmount: [0, 0, 0, 500],
        },
        tariffDescriptions: [
            {
                importantPart: '700&nbsp;000&nbsp;&#8381;',
                other: 'переводы физическим лицам без комиссии*',
            },
            {
                importantPart: '30&nbsp;платежей бесплатно',
                other: 'каждый последующий&nbsp;&ndash; 30&nbsp;&#8381;',
            },
            {
                importantPart: '1,5% на&nbsp;остаток',
            },
            {
                importantPart: '0,1&nbsp;% за&nbsp;внесение наличных',
            },
            {
                importantPart: 'Интернет-банк&nbsp;&ndash; бесплатно',
            },
            {
                importantPart: 'Эквайринг от&nbsp;1,39%',
            },
            {
                other: 'Обслуживание счета&nbsp;&ndash; 1200&nbsp;&#8381;/мес.',
            },
        ],
    },
    {
        id: 'optimum',
        title: 'Оптимум',
        maintenanceCost: 600,
        conditions: {
            paymentsCount: [90, 450, 900, 3000],
            transferAmount: [0, 0, 1000, 4000],
            withdrawalAmount: [0, 0, 500, 1000],
        },
        tariffDescriptions: [
            {
                importantPart: '600&nbsp;000&nbsp;&#8381;',
                other: 'переводы физическим лицам без комиссии*',
            },
            {
                importantPart: '30&nbsp;&#8381; за&nbsp;каждый документ',
            },
            {
                importantPart: '1,5% на&nbsp;остаток',
            },
            {
                importantPart: '0,1&nbsp;% за&nbsp;внесение наличных',
            },
            {
                importantPart: 'Интернет-банк&nbsp;&ndash; бесплатно',
            },
            {
                importantPart: 'Эквайринг от&nbsp;1,39%',
            },
            {
                other: 'Обслуживание счета&nbsp;&ndash; 600&#8381;/мес.',
            },
        ],
    },
    {
        id: 'minimum',
        title: 'Минимум',
        maintenanceCost: 0,
        conditions: {
            paymentsCount: [0, 1140, 2565, 9215],
            transferAmount: [0, 11000, 15000, 19000],
            withdrawalAmount: [0, 500, 1000, 2500],
        },
        tariffDescriptions: [
            {
                importantPart: '150&nbsp;000&nbsp;&#8381;',
                other: 'переводы физическим лицам без комиссии*',
            },
            {
                importantPart: '3&nbsp;платежа бесплатно',
                other: 'каждый последующий&nbsp;&ndash; 95&nbsp;&#8381; за&nbsp;каждый документ',
            },
            {
                importantPart: '1,5% на&nbsp;остаток',
            },
            {
                importantPart: '0,1&nbsp;% за&nbsp;внесение наличных',
                other: 'до&nbsp;100&nbsp;000&nbsp;&#8381;, свыше&nbsp;&ndash; 0.2%',
            },
            {
                importantPart: 'Интернет-банк&nbsp;&ndash; бесплатно',
            },
            {
                importantPart: 'Эквайринг от&nbsp;1,39%',
            },
            {
                other: 'Обслуживание счета&nbsp;&ndash; бесплатно',
            },
        ],
    },
];

const reliability = [
    {
        importantPart: '58&nbsp;000',
        other: 'предпринимателей работают с&nbsp;нами',
    },
    {
        importantPart: '30&nbsp;лет',
        other: 'на&nbsp;рынке',
    },
    {
        imgSrc: 'pages/business/rko/acra.svg',
        other: 'национальный рейтинг А(RU)',
    },
];

const partnersBenefts = [
    {
        title: '1С: БизнесСтарт от&nbsp;400&nbsp;&#8381;/мес',
        description: 'Деньги, налоги, товары, контрагенты, персонал',
        imgSrc: 'pages/business/rko/1c11.webp',
        discount: '-20%',
    },
    {
        title: '1С: Касса от&nbsp;100&nbsp;&#8381;/мес',
        description: 'Автоматизация магазина или небольшой торговой сети',
        imgSrc: 'pages/business/rko/1c2.webp',
        discount: '-50%',
    },
];

const ACCELERATOR_LIST_ICON_PATH = 'icons/check.svg';

const acceleratorList = [
    {
        icon: ACCELERATOR_LIST_ICON_PATH,
        value: 'Бизнес-план',
    },
    {
        icon: ACCELERATOR_LIST_ICON_PATH,
        value: 'Анализ рынка и&nbsp;конкурентов',
    },
    {
        icon: ACCELERATOR_LIST_ICON_PATH,
        value: 'Маркетинг и&nbsp;SMM',
    },
    {
        icon: ACCELERATOR_LIST_ICON_PATH,
        value: 'Продажи и&nbsp;аналитика',
    },
    {
        icon: ACCELERATOR_LIST_ICON_PATH,
        value: 'Финансы и&nbsp;учет',
    },
    {
        icon: ACCELERATOR_LIST_ICON_PATH,
        value: 'Управление персоналом и&nbsp;юридическая защита бизнеса',
    },
];

const tabsData = [
    {
        label: 'для юридического лица',
        slotName: 'legal',
    },
    {
        label: 'для ИП',
        slotName: 'entrepreneur',
    },
    // {
    //     label: 'Валютный контроль',
    //     slotName: 'control',
    // },
    {
        label: 'Архивные документы',
        slotName: 'archive',
    },
];

const archive = [
    {
        title: 'Тарифы РКО от 15.04.2024',
        href: '/files/services/smallbusiness/pdf/tarif-rko-15042024.pdf',
    },
    {
        title: 'Тарифы РКО от 19.02.2024',
        href: '/files/services/smallbusiness/pdf/tarif-rko-19022024.pdf',
    },
    {
        title: 'Тарифы РКО от 15.12.2023',
        href: '/files/services/smallbusiness/pdf/tarif-rko-15122023.pdf',
    },
    {
        title: 'Тарифы РКО от 15.09.2023',
        href: '/files/services/smallbusiness/pdf/tarif-rko-01102023.pdf',
    },
    {
        title: 'Тарифы РКО от 20.03.2023',
        href: '/files/services/smallbusiness/pdf/tarif-rko-19122022.pdf',
    },
    {
        title: 'Тарифы РКО от 24.10.2022',
        href: '/files/services/smallbusiness/pdf/tarif-rko-24102022.pdf',
    },
    {
        title: 'Тарифы РКО от 02.03.2022',
        href: '/files/services/smallbusiness/pdf/tarif-rko-02032022.pdf',
    },
    {
        title: 'Тарифы РКО от 10.02.2021',
        href: '/files/services/smallbusiness/pdf/tarif-rko-10022021.pdf',
    },
    {
        title: 'Тарифы от 01.09.2020',
        href: '/files/services/smallbusiness/pdf/tarif-rko-01092020.pdf',
    },

    {
        title: 'Приложение 2 к распоряжению 263 от 29.03.2022',
        href: '/files/services/smallbusiness/doc/prilozenie-2-k-rasporeseniu-263-ot-29.03.2022.docx',
    },

    {
        title: 'Приложение 2 к распоряжению 170 от 02.03.2022',
        href: '/files/services/smallbusiness/doc/prilozenie-2-k-rasporeseniu-170-ot-02.03.2022.docx',
    },
];

const legal = [
    {
        title: 'Паспорт финансового продукта РКО',
        href: '/media/biz/rko/pasport_rko.pdf',
    },
    {
        title: `Правила осуществления переводов между ЮЛ и ИП с использованием
        СБП (B2B) в ПАО КБ «Центр-инвест» в рамках ДКБО`,
        href: '/media/biz/dbo/pravila_sbp_b2b.pdf',
    },
    {
        title: 'Согласие для Представителя ЮЛ',
        href: '/media/biz/rko/soglasie_dlya_predstavitelya_YUL.pdf',
    },
    {
        title: 'Согласие для Бенефициара ЮЛ',
        href: '/media/biz/rko/soglasie_dlya_beneficiara_YUL.pdf',
    },
    {
        title: 'Согласие для Представителя и Бенефициара ЮЛ (одновременно)',
        href: '/media/biz/rko/soglasie_dlya_predstavitelya_i_beneficiara_YUL_odnovremenno.pdf',
    },
    {
        title: `Условия комплексного обслуживания юридических лиц и индивидуальных 
        предпринимателей ПАО КБ «Центр-инвест»`,
        href: '/media/biz/dbo/complex_service_conditions.pdf',
    },
    {
        title: 'Перечень документов, необходимых для открытия счета юридическому лицу',
        href: '/media/biz/rko/document-ur-new.pdf',
    },
    {
        title: 'Перечень документов, необходимых для открытия счета юридическому лицу&nbsp;&mdash; нерезидентом',
        href: '/media/biz/rko/document-ur-new-nerez.pdf',
    },
    {
        title: 'Заявление на&nbsp;открытие счета',
        href: '/files/services/smallbusiness/doc/zayavlenie-schet.pdf',
    },
    {
        title: 'Анкета юридического лица',
        href: '/files/services/smallbusiness/pdf/anketa-ur.pdf',
    },
    {
        title: 'Анкета&nbsp;&mdash; физического лица, являющегося бенефициарным владельцем клиента банка',
        href: '/files/services/smallbusiness/pdf/anketa-bv.pdf',
    },
    {
        title: 'Соглашение к&nbsp;договору банковского счета (заполняется в&nbsp;2-х экземплярах)',
        href: '/files/services/smallbusiness/pdf/soglas-chet.pdf',
    },
];

const entrepreneur = [
    {
        title: 'Паспорт финансового продукта РКО',
        href: '/media/biz/rko/pasport_rko.pdf',
    },
    {
        title: `Правила осуществления переводов между ЮЛ и ИП с использованием
        СБП (B2B) в ПАО КБ «Центр-инвест» в рамках ДКБО`,
        href: '/media/biz/dbo/pravila_sbp_b2b.pdf',
    },
    {
        title: 'Согласие для Представителя ЮЛ',
        href: '/media/biz/rko/soglasie_dlya_predstavitelya_YUL.pdf',
    },
    {
        title: `Условия комплексного обслуживания юридических лиц и индивидуальных 
        предпринимателей ПАО КБ «Центр-инвест»`,
        href: '/media/biz/dbo/complex_service_conditions.pdf',
    },
    {
        title: 'Перечень документов, необходимых для открытия счета индивидуальному предпринимателю',
        href: '/media/biz/rko//document-ip-new.pdf',
    },
    {
        title: 'Заявление на&nbsp;открытие счета',
        href: '/files/services/smallbusiness/doc/zayavlenie-schet.pdf',
    },
    {
        title: 'Анкета индивидуального предпринимателя',
        href: '/files/services/smallbusiness/pdf/anketa-IP.pdf',
    },
];

// const control = [
//     {
//         title: 'Сведения о&nbsp;валютных операциях',
//         href: '/files/services/smallbusiness/xls/sved_o_valut_oper.xls',
//     },
//     {
//         title: 'Справка о&nbsp;подтверждающих документах',
//         href: '/files/services/smallbusiness/xls/spravka_o_podtv_doc.xls',
//     },
//     {
//         title: 'Сведения об&nbsp;экспортном контракте',
//         href: '/files/services/smallbusiness/xls/sved_o_export_kontr.xls',
//     },
//     {
//         title: 'Заявление на&nbsp;перевод',
//         href: '/files/services/smallbusiness/doc/zayav_na_perevod.doc',
//     },
//     {
//         title: 'Заявление о&nbsp;внесении изменений в&nbsp;раздел I&nbsp;ВБК',
//         href: '/files/services/smallbusiness/doc/zayav_o_vnes_izm_razI_VKB.doc',
//     },
//     {
//         title: 'Заявление о&nbsp;снятии с&nbsp;учета контрактов (кредитных договоров)',
//         href: '/files/services/smallbusiness/doc/zayav_o_snat_s_ucheta_kontr.doc',
//     },
// ];

const currenciesList = [
    {
        currencie: 'Валютное РКО <strong>в лирах</strong>',
        country: 'Денежная единица <br>Турции',
        image: 'pages/business/rko/lira.webp',
        background: 'first',
        href: '#rko-benefits',
    },
    {
        currencie: 'Валютное РКО <strong>в манатах</strong>',
        country: 'Денежная единица <br>Азербайджанской Республики',
        image: 'pages/business/rko/manats.webp',
        background: 'second',
        href: '#rko-benefits',
    },
];

export {
    slidesData,
    offerSlidesData,
    infoListItems,
    advantages,
    tariffs,
    reliability,
    partnersBenefts,
    acceleratorList,
    tabsData,
    legal,
    entrepreneur,
    archive,
    currenciesList,
    info,
};
